import api from "@/api/client";

export function bootstrapQueryKey(userId) {
  return ["bootstrap", userId?.toString()];
}

export async function fetchBootstrap() {
  const { data } = await api.get("/bootstrap");

  return data;
}
